<template>
  <div class="container-lg">
    <div>
      <p class="fs-3 fw-bold mb-4">
        <i class="fa-solid fa-user-gear" />
        管理者
      </p>
      <div class="row">
        <div class="col-9">
          <Loader :flag="flag.isLoading">
            <ul
              class="list-group list-group-checkable d-grid gap-2 border-0"
              v-if="!flag.isLoading">
              <div v-if="!users?.length" class="mt-3">
                <p class="fs-6">※管理者が登録されていません。新規登録してください。</p>
              </div>
              <li
                v-else
                v-for="admin of users" :key="admin.id"
                :class="[s.item, editId === admin.id ? s.edit : '', admin.flag === 10 ? 'bg-light' : '']"
                class="list-group-item rounded-3 py-3">
                <div
                  v-if="editId !== admin.id"
                  class="d-flex align-items-center justify-content-between">
                  <div>{{ admin.username || '名前未設定' }}<span class="d-block small opacity-50">{{ admin.email }}</span></div>
                  <div>
                    <button
                      v-if="admin.flag === 1"
                      @click="startEdit(admin)"
                      class="btn btn-outline-success btn-sm">変更</button>
                  </div>
                </div>
                <div
                  :class="s.form"
                  v-else>
                  <div>
                    <label for="">メールアドレス</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="updateData.email">
                  </div>
                  <div class="mt-3">
                    <label for="">名前</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="updateData.username">
                  </div>
                  <div class="mt-3">
                    <label for="">権限</label>
                    <select
                      class="form-control form-control-sm"
                      name="role"
                      id="role"
                      v-model="updateData.role">
                      <option
                        v-for="r in roles"
                        :key="r.name"
                        :value="r.role"
                        :selected="r.role === admin.role.role"
                        v-show="r.name !== 'developer' || user.role && user.role.role === 22">{{ r.label }}</option>
                    </select>
                  </div>
                  <div class="d-flex mt-3">
                    <button
                      class="btn btn-primary btn-sm"
                      :disabled="!updateData.email || !updateData.username"
                      @click="regist">更新</button>
                    <button
                      @click="cancelEdit()"
                      class="btn btn-outline-danger btn-sm ms-2">キャンセル</button>
                  </div>
                </div>
              </li>
            </ul>
          </Loader>
        </div>
        <div class="col-3 cards">
        <div class="card mb-4">
          <div class="card-header"><i class="fa-regular fa-magnifying-glass me-2"/>検索</div>
          <div class="card-body" :class="s.form">
            <div class="text-start">
              <label for="" class="ms-1">キーワード</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="searchParams.keyword">
            </div>
            <div class="text-start mt-2">
              <label for="" class="ms-1">権限</label>
              <select
                class="form-control form-control-sm"
                name="role"
                id="role"
                v-model="searchParams.role">
                <option :value="0">選択してください</option>
                <option
                  v-for="r in adjustedRoles"
                  :key="r.name"
                  :value="r.role"
                  v-show="r.name !== 'developer' || user.role && user.role.role === 22">{{ r.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header"><i class="fa-regular fa-pen-to-square me-2"/>新規登録</div>
            <div class="card-body" :class="s.form">
              <div class="text-start">
                <label for="email" class="ms-1">メールアドレス</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model.trim="$v.mail.$model"
                  v-bind:class="{ input_error: validationFlags.mail }"
                  v-on:input="invalidsCheck('mail', $v.mail.$invalid)"
                  :disabled="editId">
                  <p
                    :class="s.comment"
                    v-if="$v.mail.$dirty
                      && $v.mail.required.$invalid">メールアドレスを入力してください</p>
                  <p
                    :class="s.comment"
                    v-if="$v.mail.$dirty
                      && $v.mail.email.$invalid">正しいメールアドレスの形式で入力してください</p>
              </div>
              <div class="mt-3 text-start">
                <label for="email" class="ms-1">名前</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="username"
                  :disabled="editId">
              </div>
              <div class="mt-3 text-start">
                <label for="role" class="ms-1">権限</label>
                <select
                  class="form-control form-control-sm"
                  name="role"
                  id="role"
                  v-model="role"
                  :disabled="editId">
                  <option
                    v-for="r in adjustedRoles"
                    :key="r.name"
                    :value="r.role"
                    :selected="r.role === role"
                    v-show="r.name !== 'developer' || user.role && user.role.role === 22">{{ r.label }}</option>
                </select>
              </div>
              <button
                :disabled="!mail || !username"
                @click="regist"
                class="btn btn-primary w-100 py-2 mt-3">登録</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { mapState } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from 'vuelidate/lib/validators';
import {
  Loader,
} from '@/components/parts';

export default {
  name: 'admin-user',
  components: {
    Loader,
  },
  data() {
    return {
      flag: {
        isLoading: true,
        changeKeyword: false,
      },
      validationFlags: {
        mail: false,
      },
      invalids: {
        mail: true,
      },
      // 有効期限切れでリダイレクトされた
      isExpired: false,
      users: [],
      searchParams: {
        role: 0,
        keyword: null,
      },
      username: null,
      role: 11,
      updateData: {
        email: null,
        username: null,
        role: 11,
      },
      editId: null,
      roles: [
        {
          name: 'admin',
          label: '管理者',
          role: 11,
        },
        {
          name: 'developer',
          label: '開発管理者',
          role: 21,
        },
      ],
      targetColumns: ['username', 'email'],
    };
  },
  created() {
    this.getUsers();
  },
  setup() {
    const mail = ref('');

    const rules = {
      // メールは必須・email形式
      mail: { required, email },
    };

    const $v = useVuelidate(rules, { mail });

    return { mail, $v };
  },
  computed: {
    ...mapState(['user']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.mail;
    },
    adjustedRoles() {
      if (!this.user.id) return [];
      if (this.user.role.role === 22) return this.roles;
      if (this.user.role.role === 21) return this.roles.filter((role) => role.role !== 22);
      return this.roles.filter((role) => ![21, 22].includes(role.role));
    },
  },
  watch: {
    user: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
    searchParams: {
      handler() {
        if (!this.editId) {
          this.getUsers();
        }
      },
      deep: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getUsers() {
      if (!this.user.id) return;
      this.flag.isLoading = true;

      const params = {
        role: [11],
        flags: [1, 10],
      };

      if (this.user.role.role === 21) params.role.push(21); // 開発者は管理者も表示
      if (this.searchParams.role) params.role = [this.searchParams.role];
      if (this.searchParams.keyword) {
        params.targetColumn = this.targetColumns;
        params.keyword = [this.searchParams.keyword];
      }

      this.axios({
        method: 'get',
        url: 'v1/user/get/list',
        params,
      })
        .then((response) => {
          this.users = response.data.list.data;
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。');
        })
        .finally(() => {
          this.flag.isLoading = false;
        });
    },

    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    init() {
      this.mail = null;
      this.role = 21;
      this.username = null;
      this.editId = null;
      this.updateData.email = null;
      this.updateData.role = null;
      this.updateData.username = null;
    },

    startEdit(user) {
      this.init();
      this.editId = user.id;
      this.updateData.email = user.email;
      this.updateData.username = user.username;
      this.updateData.role = user.role.role;
    },

    cancelEdit() {
      this.init();
    },

    /** サブミット */
    regist(e) {
      e.preventDefault();
      this.showLoading();

      this.flag.isLoading = true;

      const endpoint = this.editId ? 'update' : 'create';

      const data = {
        email: this.updateData.email || this.mail,
        username: this.updateData.username || this.username,
        role: this.updateData.role || this.role,
      };

      if (endpoint === 'create') {
        data.flag = 10;
      }
      if (endpoint === 'update') data.id = this.editId;

      this.axios({
        method: 'POST',
        url: `/v1/user/${endpoint}`,
        data,
      })
        .then((response) => {
          const res = response.data;
          if (endpoint === 'create' && res.exists) {
            alert('既に登録されているメールアドレスです。');
          } else if (res.userId && endpoint === 'create') {
            alert('入力されたメールアドレスにパスワード設定用のメールを送信しました。');
            this.init();
          }
          if (endpoint === 'update') {
            alert('管理者情報を更新しました。');
            this.init();
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.isLoading = false;
          this.getUsers();
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  display: flex;
  justify-content: center;
}

.title {
  text-align: center;
  color: var(--orange-main);
}

.form {
  text-align: center;
}

.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #666;
  font-weight: bold;
  color: #fff;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
}
.form {
  label {
    color: var(--label-secondary);
    font-size: 14px;
    font-weight: 700;
  }
}
.item {
  transition: all .5s;
  max-height: 80px;
  overflow: hidden;
  &.edit {
    max-height: 1000px;
  }
}

.message {
  font-size: 12px;
  text-align: center;
}

.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  input {
    width: 100%;
    padding: 13px;
    border-radius: 8px;
    border: none;
    background-color: var(--gray-sub);
    outline: none;
  }
}
.comment {
  font-size: 12px;
  color: var(--red);
}
</style>

<style lang="scss" scoped>
.list-group-item {
  border-top-width: 1px !important;
}
</style>
